<template>
    <div v-if="EditMode">
        <div class="row">
            <div class="col-8">
                <jet-label for="productSelect" value="Product" />
            </div>
            <div class="col-2">
                <jet-label for="quantity" value="Quantity" />
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-8 form-group">
                <Multiselect id="productSelect" v-model="form.selectedSkus" :searchable="true" mode="tags"
                    :options="availableProducts" class="admin-multiselect" placeholder="Select Products">
                </Multiselect>
            </div>
            <div class="col-2">
                <jet-input id="quantity" type="text" class="form-control" v-model="form.quantity" />
            </div>
            <div class="col-2" style="vertical-align: bottom;">
                <jet-button class="btn btn-primary mb-2" :disable="isBusy" @click="upsertSetItem">Add</jet-button>
            </div>
        </div>
    </div>
    <div v-if="productSetParts.length > 0">
        <DataTable :value="productSetParts" :paginator="false"
            class="p-datatable-sm admin-datatable product_set_parts-table"
            tableClass="border-left border-right border-bottom" breakpoint="500px">
            <Column field="product_id" header="Product Id" />
            <Column field="product.sku" header="SKU" />
            <Column field="quantity" header="Quantity" />
            <Column field="product.current_inventory" header="Inventory" />
            <Column filed="product.price_mtn" header="Cost">
                <template #body="slotProps">
                    {{ formatDollars(slotProps.data.product.price_mtn) }}
                </template>
            </Column>
            <Column v-if="EditMode">
                <template #body="slotProps">
                    <a href="javascript:void(0)" @click="deleteSetItem(slotProps.data.id)">
                        <i class="fa fa-trash text-danger"></i>
                    </a>
                </template>
            </Column>
        </DataTable>
        <div class="row mt-4 mb-2">
            <div class="col-6 text-center">
                <jet-button class="btn btn-primary mb-2" v-if="!CanSplitSet" :disable="isBusy" @click="splitSet"><i
                        class="fa-solid fa-right-from-bracket"></i> Split Set</jet-button>
            </div>
            <div class="col-6 text-center">
                <jet-button class="btn btn-primary mb-2" v-if="!CanMakeSet" :disable="isBusy" @click="makeSet"><i
                        class="fa-solid fa-right-to-bracket"></i> Make Set</jet-button>
            </div>
        </div>
    </div>
    <span v-else><strong>Set Not Defined</strong></span>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetLabel from '@/Jetstream/Label'
import JetInput from '@/Jetstream/Input'
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        JetButton,
        JetLabel,
        JetInput,
        Multiselect,
    },
    props: {
        ProductId: Number,
        CanMakeSet: Boolean,
        CanSplitSet: Boolean,
        ProductSetParts: Array,
        EditMode: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                selectedSkus: null,
                quantity: 1,
            }),
            productSetParts: this.ProductSetParts,
            availableProducts: [],
            isBusy: false,
        }
    },
    mounted: function () {
        this.getAvailableSetProducts();
    },
    methods: {
        upsertSetItem() {
            this.isBusy = true;
            this.form.post(this.route('products.upsertSetItems', this.ProductId), {
                preserveScroll: true,
                onSuccess: (response) => {
                    this.productSetParts = response.props.ProductSetParts;
                    this.form.quantity = 1;
                    this.form.selectedSkus = null;
                    this.isBusy = false;
                },
                onFinish: () => this.isBusy = false,
            })
        },
        deleteSetItem(productSetPartId) {
            this.$confirm.require({
                message: "Are you sure you want to delete this item from the Set?",
                header: "Delete Set Item",
                icon: 'text-danger pi pi-exclamation-triangle',
                acceptLabel: "Yes",
                rejectLabel: "Cancel",
                accept: () => {
                    axios.post(this.route('products.deleteSetItem', productSetPartId)).then((response) => {
                        if (response.status == 200) {
                            this.productSetParts = response.data.ProductSetParts;
                        }
                    });
                }
            })
        },
        getAvailableSetProducts() {
            axios.get(this.route('products.getAvailableSetProducts', this.ProductId)).then((response) => {
                if (response.status == 200) {
                    this.availableProducts = response.data.AvailableSetProducts;
                }
            });
        },
        splitSet() {
            this.$confirm.require({
                message: "Are you sure you want to split a set into parts?",
                header: "Spit Set",
                icon: 'text-danger pi pi-exclamation-triangle',
                acceptLabel: "Yes",
                rejectLabel: "Cancel",
                accept: () => {
                    this.isBusy = true
                    this.form.post(this.route('products.splitSet', this.ProductId), {
                        preserveScroll: true,
                        onSuccess: () => { window.location.reload(true) },
                        onError: () => { this.isBusy = false },
                    })
                }
            })
        },
        makeSet() {
            this.$confirm.require({
                message: "Are you sure you want to make a set from available parts?",
                header: "Make Set",
                icon: 'text-danger pi pi-exclamation-triangle',
                acceptLabel: "Yes",
                rejectLabel: "Cancel",
                accept: () => {
                    this.isBusy = true
                    this.form.post(this.route('products.makeSet', this.ProductId), {
                        preserveScroll: true,
                        onSuccess: () => { window.location.reload(true) },
                        onError: () => { this.isBusy = false },
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
.product_set_parts-table {

    .p-datatable thead.p-datatable-thead th,
    .p-datatable-table thead.p-datatable-thead th,
    .p-datatable-sm thead.p-datatable-thead th {
        background: gray !important;
    }

    .p-datatable thead.p-datatable-thead th.p-highlight,
    .p-datatable-table thead.p-datatable-thead th.p-highlight,
    .p-datatable-sm thead.p-datatable-thead th.p-highlight {
        color: gray !important;
    }

    .p-column-header-content {
        padding-left: 0.25rem !important;
    }

    .p-datatable-tbody td {
        padding-left: 0.25rem !important;
    }

}
</style>
